<template>

  <div>

    <!-- show loading indicator -->
  	<loading-indicator :loading="isLoading"></loading-indicator>

    <template v-if="!isLoading">

      <!-- page-heading -->
      <page-heading :show="true" pageTitle="NEWSLETTER-HEADLINE"></page-heading>


      <!-- NEWSLETTER OVERVIEW -->
      <!-- ------------------- -->
      <tabs v-if="userRole== 'Administrator'" type="boxed" size="normal">

        <!-- tab: REDAKTIONSPLAN -->
        <tab-item :label="$t('NEWSLETTER-TAB-EDITORIAL_PLAN')">

            <!-- <h2>Apothekenkatalog {{ $store.getters.getCatalogName }}</h2> -->
            <h2>Apothekenkatalog {{ currentCatalogName }}</h2>

            <v-client-table ref="tblNewsletter" name="tblNewsletter" :data="newsletters" :columns="newsletter.columns" :options="newsletter.options" class="tbl-newsletter noFirstColumn">

                <!-- name -->
                <template slot="name" slot-scope="props">
                    <strong>{{ props.row.name }}</strong>
                </template>

                <template slot="scheduleDate" slot-scope="props">
                    <strong>{{ formatDate2(props.row.scheduleDate, false) }}</strong>
                </template>

                <!-- options -->
                <template slot="edit" slot-scope="props">

                    <span class="icon is-small" @click.stop="newsletterEdit(props.row)" title="Newsletter bearbeiten">
                        <i class="icon-ak-bearbeiten"></i>
                    </span>

                    <pop-confirm class="icon is-small" content="Möchten Sie diesen Newsletter wirklich entfernen?" icon="question-circle-o" :on-ok="function() { newsletterDelete(props.row) }" cancel-text="nein" title="Newsletter löschen">
                        <i class="icon-ak-entfernen"></i>
                    </pop-confirm>

                </template>


                <template slot="child_row" slot-scope="props">

                    <draggable
                        :list="props.row.elements"
                        :options="{
                            animation: 200,
                            handle: '.dragHandler',
                            draggable: '.list-complete-item',
                        }"
                        @end="onDragComplete(props.row.elements, props.row.id)">

                            <div v-for="(article, index) in props.row.elements" class="columns articles list-complete-item" :key="article.id">

                                <div class="column is-narrow">
                                    <div class="imgWrapper lazy-img-fadein" v-lazy:background-image="$config.assets + article.catalogPageElement.image" :key="article.id"></div>
                                </div>

                                <div class="column">
                                    <div class="preview">
                                        <span class="headline">{{ article.catalogPageElement.headline }}</span>
                                        <div v-html="getExcerpt(article.catalogPageElement, 500)"></div>
                                    </div>
                                </div>

                                <div class="column is-narrow">
                                    <span class="icon is-small dragHandler has-cursor-move">
                                        <i class="icon-ak-move"></i>
                                    </span>
                                </div>

                                <div class="column is-narrow">
                                    <pop-confirm class="icon is-small has-pointer" content="Möchten Sie diesen Beitrag wirklich entfernen?" icon="question-circle-o" cancel-text="nein" :on-ok="function() { newsletterArticleRemove(props.row.id, index) }">
                                        <i class="fa icon-ak-entfernen"></i>
                                    </pop-confirm>
                                </div>

                            </div>

                    </draggable>

                    <div class="columns articles new" v-if="props.row.elements && props.row.elements.length < maxArticles">
                        <div class="column">
                            <div class="imgWrapper plain has-pointer" @click="loadArticles(props.row.id)">
                                <span class="icon"><i class="icon-ak-hinzufuegen"></i></span>
                            </div>
                        </div>
                    </div>

                </template>

            </v-client-table>


            <div class="tabButtons">
                <!--
                <custom-button name="NEWSLETTER-BTN-PRINT" type="dark" size="small" icon="icon-ak-print"></custom-button>
                <custom-button name="NEWSLETTER-BTN-EXPORT" type="dark" size="small" icon="icon-ak-export"></custom-button>
                -->
                <custom-button name="NEWSLETTER-BTN-ADD" type="blue" size="small" icon="icon-ak-hinzufuegen" @click.native="newsletterAdd"></custom-button>
            </div>

        </tab-item>

        <!-- tab: APOTHEKEN -->
        <tab-item :label="$t('NEWSLETTER-TAB-PHARMACIES')">

          <h2>Apothekenkatalog  {{ currentCatalogName }}</h2>

          <v-client-table ref="tblNewsletterPharmacies" name="tblNewsletterPharmacies" :data="newsletterPharmacies.data" :columns="newsletterPharmacies.columns" :options="newsletterPharmacies.options" class="tbl-newsletterPharmacies">

              <!-- before table: FILTER OPTIONS -->
              <template slot="beforeTable">

                  <div class="columns is-marginless is-pulled-right filters">

                      <!-- filter newsletter -->
                      <div class="column">
                          <form-input inputType="select" label="NEWSLETTER-PHARMACIES-FILTER_NEWSLETTER_NAME" v-model="filterPharmaciesNewsletterName" :selectAllowEmpty="false" :selectOptions="newsletterSelectOptions" :showLabel="false" selectFieldName="name" :showLabelInOptions="false" class="is-pulled-right"></form-input>
                      </div>

                      <!-- filter newsletter sent -->
                      <div class="column">
                          <form-input inputType="select" label="NEWSLETTER-PHARMACIES-FILTER_NEWSLETTER_SENT" :selectAllowEmpty="false" v-model="filterPharmaciesNewsletterSent" :selectOptions="filterPharmaciesNewsletterSentOptions" :showLabel="false" :showLabelInOptions="false" class="is-pulled-right"></form-input>
                      </div>

                  </div>

              </template>

              <template slot="h__select">
                  <p-check name="check" color="primary" class="p-default p-curve p-smooth" v-model="pharmaciesMarkedAll" @click.prevent.native="pharmaciesToggleAll()"></p-check>
              </template>

              <!-- checkbox -->
              <template slot="select" slot-scope="props">
          		<div class="checkboxWrapper">
                      <p-check name="check" color="primary" :value="props.row.id" v-model="pharmaciesMarkedRows" class="p-default p-curve p-smooth"></p-check>
                  </div>
          	</template>

              <template slot="date" slot-scope="props">

                  <template v-if="props.row.newsletters.length > 0">

                      <template v-for="(newsletter, index) in props.row.newsletters">

                          <template v-if="newsletter.newsletter == filterPharmaciesNewsletterName.newsletter && newsletter.email != null">
                              {{ newsletter.email }}
                          </template>

                          <template v-else>
                              <template v-if="index==0">
                                  -
                              </template>

                          </template>

                      </template>

                  </template>

                  <template v-else>
                      -
                  </template>

              </template>

              <!-- bulk action -->
              <template slot="afterTable">

                  <span :class="['button is-light', { 'is-disabled': pharmaciesMarkedRows.length == 0 }]" @click="reminderOpen">
                      <span class="icon is-small"><i class="icon-ak-reminder"></i></span>Reminder versenden
                  </span>

              </template>

          </v-client-table>

          <div class="tabButtons">
              <!--
              <custom-button name="NEWSLETTER-BTN-PRINT" type="dark" size="small" icon="icon-ak-print"></custom-button>
              <custom-button name="NEWSLETTER-BTN-EXPORT" type="dark" size="small" icon="icon-ak-export"></custom-button>
              -->
          </div>

        </tab-item>

      </tabs>

      <!-- MODAL -->
      <modal
        :width="modal.width"
        :title="modal.title"
        transition="fadeDown"
        cancel-text="Abbrechen"
        :show-ok="false"
        :backdrop-closable="false"
        :is-show="showModal"
        :class="['vcenter', modal.class]"
        @close="closeModal">

        <template v-if="modal.isLoading">
            <loading-indicator></loading-indicator>
        </template>

        <template v-else>

          <!-- SELECT ARTICLES -->
          <template v-if="['articles', 'siteNewsletterArticles'].indexOf(modal.type) > -1">

              <v-client-table ref="tblNewsletterArticles" name="tblNewsletterArticles" :data="articles.data" :columns="articles.columns" :options="articles.options" class="noFirstColumn">

                  <!-- before table: FILTER OPTIONS -->
                  <template slot="beforeTable">

                      <!-- search -->
                    <div class="control has-icon search is-pulled-left">
                        <input class="input" type="text" v-model.trim="articleSearchString" placeholder="Suchbegriff">
                        <i class="fa fa-search" aria-hidden="true"></i>
                    </div>

                  </template>

                  <!-- checkbox -->
                  <template slot="select" slot-scope="props">
                      <div class="checkboxWrapper">
                          <p-check name="check" color="primary" :value="props.row.id" v-model="markedRows" class="p-default p-curve p-smooth"></p-check>
                      </div>
                  </template>

                  <!-- image -->
                  <template slot="asset" slot-scope="props">
                      <div class="imgWrapper lazy-img-fadein" v-lazy:background-image="$config.assets +  props.row.image" :key="props.row.id"></div>
                  </template>

                  <!-- name -->
                  <template slot="name" slot-scope="props">
                      {{ props.row.headline }}
                  </template>

              </v-client-table>

              <div slot="footer">
                  <span class="button" @click="closeModal">schließen</span>

                  <template v-if="modal.type == 'articles'">
                      <span :class="['button is-success', { 'is-loading': modal.isSaving }, { 'is-disabled': markedRows.length == 0 || markedRows.length > maxArticles }]" @click="newsletterAppendArticles">übernehmen</span>
                  </template>

                  <template v-else>
                      <span :class="['button is-success', { 'is-loading': modal.isSaving }, { 'is-disabled': markedRows.length == 0 || markedRows.length > maxArticles }]" @click="siteNewsletterAppendArticles">übernehmen</span>
                  </template>
              </div>

          </template>

          <!-- NEWSLETTER ADD -->
          <template v-else-if="modal.type == 'newsletterAdd'">

            <form-input inputType="text" label="NEWSLETTER-EDIT-TITLE" v-model="tmpEntry.name" :isHorizontal="false"></form-input>

            <div class="control">
  						<div class="control-label">
  							<label-name labelKey="NEWSLETTER-EDIT-DISTRIBUTION_DATE"></label-name>
  						</div>
  						<div class="control">
  							<datepicker placeholder="Datum wählen" :options="datePickerOptions" v-model="tmpEntry.scheduleDate"></datepicker>
  						</div>
  					</div>

            <div slot="footer">
              <span class="button" @click="closeModal">schließen</span>
              <span :class="['button is-success', { 'is-loading': modal.isSaving }, { 'is-disabled': tmpEntry.name == '' || tmpEntry.scheduleDate == null }]" @click="newsletterAddOk">anlegen</span>
            </div>

          </template>

          <!-- NEWSLETTER EDIT -->
          <template v-else-if="modal.type == 'newsletterEdit'">

            <form-input inputType="text" label="NEWSLETTER-EDIT-TITLE" v-model="tmpEntry.name" :isHorizontal="false"></form-input>

            <div class="control">
  						<div class="control-label">
  							<label-name labelKey="NEWSLETTER-EDIT-DISTRIBUTION_DATE"></label-name>
  						</div>
  						<div class="control">
                <datepicker placeholder="Datum wählen" :options="datePickerOptions" disabled v-model="tmpEntry.scheduleDate" :key="tmpEntry.id"></datepicker>
  						</div>
  	        </div>

            <div slot="footer">
                <span class="button" @click="closeModal">schließen</span>
                <span :class="['button is-success', { 'is-loading': modal.isSaving }, { 'is-disabled': tmpEntry.name == '' && tmpEntry.scheduleDate == null }]" @click="newsletterEditOk">speichern</span>
            </div>

          </template>

          <!-- NEWSLETTER -->
          <template v-else-if="modal.type == 'newsletter'">

              <p>Wollen Sie den Newsletter an alle eMail-Adressen aus der Empfänger-Liste versenden?</p>

              <div slot="footer">
                  <span class="button" @click="closeModal">abbrechen</span>
                  <span class="button is-success" @click="newsletterSendOk">senden</span>
              </div>

          </template>


          <!-- REMINDER -->
          <template v-else-if="modal.type == 'reminder'">

  					<div class="control froalaRTE froalaPlain" :key="modal.type">
  						<froala id="froala" ref="froala" :tag="'textarea'" :config="froalaConfig" v-model="reminderText"></froala>
  					</div>

            <div slot="footer">
              <span class="button" @click="closeModal">abbrechen</span>
              <span :class="['button is-success', { 'is-loading': modal.isSaving }]" @click="reminderSend">senden</span>
            </div>

          </template>

          <!-- TEST NEWSLETTER -->
          <template v-else-if="modal.type == 'testNewsletter'">

              <template v-if="progressStatus == null">

                  <form-input v-model="testRecipient" placeholder="Email des Empfängers"></form-input>

                  <div slot="footer">
                      <span class="button" @click="closeModal">abbrechen</span>
                      <span :class="['button is-success', { 'is-loading': modal.isSaving }]" @click="newsletterSendTestOk">senden</span>
                  </div>
              </template>

              <template v-else>

                  <template v-if="progressStatus.status != 'Finished'">

                      <div class="has-text-centered" style="margin-bottom: 5px;">{{ progressStatus.log }}</div>
                      <progress-bar :percent="progressStatus.progress" :showinfo="false" :striped="true" :animated="true" size="large"></progress-bar>

                  </template>

                  <template v-else>

                      <div class="has-text-centered">Test Email erfolgreich versandt!</div>

                  </template>


              </template>

          </template>


          <!-- PROGRESS NEWSLETTER RECIPIENT -->
          <template v-else-if="modal.type == 'progress'">

              <template v-if="progressStatus == null">

                  <loading-indicator-small></loading-indicator-small>

              </template>

              <template v-else>

                  <template v-if="progressStatus.status != 'Finished'">

                      <div class="has-text-centered" style="margin-bottom: 5px;">{{ progressStatus.log }}</div>
                      <progress-bar :percent="progressStatus.progress" :showinfo="false" :striped="true" :animated="true" size="large"></progress-bar>

                  </template>

                  <template v-else>

                      <div class="has-text-centered">Empfänger erfolgreich hochgeladen</div>

                  </template>

              </template>

          </template>


        </template>

      </modal>


    </template>

  </div>
</template>


<script>
import Vue from 'vue';
import { ClientTable, Event } from 'vue-tables-2';
Vue.use(ClientTable, {}, false, 'bulma');

// https://lokesh-coder.github.io/pretty-checkbox/
import PrettyCheckbox from 'pretty-checkbox-vue';
Vue.use(PrettyCheckbox);

import { de } from 'flatpickr/dist/l10n/de';

// Require Froala Editor js and css files
require('froala-editor/js/froala_editor.pkgd.min')
require('froala-editor/css/froala_editor.pkgd.min.css')
require('froala-editor/js/languages/de.js')
require('froala-editor/css/froala_style.min.css')
import VueFroala from 'vue-froala-wysiwyg';
Vue.use(VueFroala);


// import siteNewsletter from './siteNewsletter';
import vue2Dropzone from '../utils/dropzoneWrapper';
import exportButton from '../utils/exportButton'
import draggable from 'vuedraggable';

export default {

    components: {
        VueFroala,
        vueDropzone: vue2Dropzone,
        draggable,
        exportButton
    },

    data() {

        var self = this;

        return {

            currentCatalogName: "",

            isLoading: false,
            isSaving: false,
            isSending: false,
            isSendingTest: false,

            showModal: false,

            maxArticles: 4,
            refreshIntervalId: null,
            progressStatus: null,

            articleSearchString: '',
			markedRows: [],
            activeRowId: null,
            activeRowIndex: null,

            pharmaciesMarkedAll: false,
            pharmaciesMarkedRows: [],

            testRecipient: '',

            newsletters: [],
            siteNewsletters: [],

            reminderText: '',

            selectedNewsletterId: null,
            changedNewsletter: null,

            filterPharmaciesNewsletterName: null,
            filterPharmaciesNewsletterSent: { id: 1, name: 'alle' },
            filterPharmaciesNewsletterSentOptions: [{ id: 1, name: "alle"}, { id: 2, name: 'versendet' }, { id: 3, name: 'nicht versendet' }],

            tmpEntry: {
                id: null,
                name: '',
                scheduleDate: null,
                articles: []
            },

            modal: {
                isLoading: false,
                isSaving: false,
                type: 'articles',
                title: '',
                width: '880',
                class: ''
            },

            datePickerOptions: {
                enableTime: false,
                altInput: true,
                altFormat: 'd.m.Y',
                locale: de,
		            clickOpens: true,
                weekNumbers: true
            },

            // NEWSLETTER
            newsletter: {
              columns: ['name', 'scheduleDate', 'edit'],
              options: {
                trackBy: 'id',
                uniqueKey: 'id',
                saveState: false,
                perPage: 15,
                orderBy: {
                    ascending: false,
                    column: 'scheduleDate'
                },

                // custom table headings
                headings: {
                    name(h) {
                        return <lang labelKey="NEWSLETTER-TBL_HEADER-NAME"></lang>
                    },
                    scheduleDate(h) {
                        return <lang labelKey="NEWSLETTER-TBL_HEADER-DISTRIBUTION_DATE"></lang>
                    },
                    edit(h) {
                        return "";
                    },
                },

                columnsClasses: { 'edit': 'edit' },

                sortable: ['name', 'scheduleDate'],
                sortIcon: {
                    base:'fa',
                    up:'fa-sort-up',
                    down:'fa-sort-down',
                    is:'fa-sort'
                },
                filterByColumn: false,
                filterable: false,

                texts: {
                    filter: 'Filter Ergebnisse:',
                    filterPlaceholder: 'Suche',
                    limit: 'Einträge pro Seite',
                    noResults: 'keine passenden Einträge gefunden',
                    count: '{from} bis {to} von {count} Einträgen|{count} Einträge|ein Eintrag'
                },

                pagination: {
                    chunk: 5
                },

                skin: 'table is-hoverable is-fullwidth',

              }
            },

            // PHARMACIES
            newsletterPharmacies: {
                data: [],
                columns: ['select', 'date', 'extRef', 'name'], /* , 'customers' */
                options: {
                    trackBy: 'id',
                    uniqueKey: 'id',
                    saveState: false,
                    perPage: 25,
                    orderBy: {
                        ascending: true,
                        column: 'name'
                    },

                    // custom table headings
                    headings: {
                      status(h) {
                      },
                      date(h) {
                          return <lang labelKey="NEWSLETTER-PHARMACIES-TBL_HEADER-DATE"></lang>
                      },
                      extRef(h) {
                          return <lang labelKey="NEWSLETTER-PHARMACIES-TBL_HEADER-ID"></lang>
                      },
                      name(h) {
                          return <lang labelKey="NEWSLETTER-PHARMACIES-TBL_HEADER-NAME"></lang>
                      },
                      customers(h) {
                          return <lang labelKey="NEWSLETTER-PHARMACIES-TBL_HEADER-CUSTOMERS"></lang>
                      },
                      select(h) {
                          return <lang labelKey="NEWSLETTER-PHARMACIES-TBL_HEADER-SELECT"></lang>
                      },
                    },

                    sortable: ['name', 'extRef'],
                    sortIcon: {
                      base:'fa',
                      up:'fa-sort-up',
                      down:'fa-sort-down',
                      is:'fa-sort'
                    },
                    filterByColumn: false,
                    filterable: false,

                    texts: {
                      filter: 'Filter Ergebnisse:',
                      filterPlaceholder: 'Suche',
                      limit: 'Einträge pro Seite',
                      noResults: 'keine passenden Einträge gefunden',
                      count: '{from} bis {to} von {count} Einträgen|{count} Einträge|ein Eintrag'
                    },

                    pagination: {
                        chunk: 5
                    },

                    skin: 'table is-striped is-hoverable is-fullwidth',

                    // custom filter functions
                    customFilters: [
                      {
                        name: 'search',
            						callback(row, string) {

            							if(string == null || string == "") {
            								return true;
            							}

            							string = string.toLowerCase();
            							return row.catalogPage.name.toLowerCase().indexOf(string) > -1;
            						}
                      },
                      {
                        name: 'filter',
                        callback(row, payload) {

                          let sentOption = payload.sentOption.name;
                          let newsletterId = payload.newsletter == null ? null : payload.newsletter.id;


                          if(sentOption != 'alle') {

                            if(sentOption == 'nicht versendet') {
                              // return !row.newsletters.findIndex((n) => { n.email == null }) > -1;
                              return row.newsletters.length == 0 || row.newsletters.length > 0 && row.newsletters.findIndex((newsletter) => newsletter.newsletter == newsletterId) == -1;
                            }

                            else {
                              return row.newsletters.length > 0 && row.newsletters.findIndex((newsletter) => newsletter.newsletter == newsletterId) > -1;
                            }

                          } else {

                            return true;

                          }

                        }
                      }
                    ],

                    rowClassCallback(row) {
                      return 'status' + (self.isNewsletterSent(row.newsletters) ? ' SENT' : '');
          						// return 'status ' + (row.newsletters.email != null ? 'SENT' : '');
          					}

                },


            },

            // RECIPIENTS
            recipients: {

                data: [],
                columns: ['salutation', 'lastname', 'firstname', 'email', 'edit'],
                options: {
                    trackBy: 'email',
                    uniqueKey: 'email',
                    saveState: false,
                    perPage: 15,
                    orderBy: {
                        ascending: true,
                        column: 'lastname'
                    },

                    // custom table headings
                    headings: {

                      salutation(h) {
                          return <lang labelKey="NEWSLETTER-RECIPIENTS-TBL_HEADER-SALUTATION"></lang>
                      },
                      firstname(h) {
                          return <lang labelKey="NEWSLETTER-RECIPIENTS-TBL_HEADER-FIRSTNAME"></lang>
                      },
                      lastname(h) {
                          return <lang labelKey="NEWSLETTER-RECIPIENTS-TBL_HEADER-LASTNAME"></lang>
                      },
                      email(h) {
                          return <lang labelKey="NEWSLETTER-RECIPIENTS-TBL_HEADER-EMAIL"></lang>
                      },
                      edit(h) {
                          return '';
                      }

                    },

                    columnsClasses: { 'edit': 'edit' },

                    sortable: ['firstname', 'lastname', 'email'],

                    sortIcon: {
                      base:'fa',
                      up:'fa-sort-up',
                      down:'fa-sort-down',
                      is:'fa-sort'
                    },
                    filterByColumn: false,
                    filterable: false,

                    texts: {
                      filter: 'Filter Ergebnisse:',
                      filterPlaceholder: 'Suche',
                      limit: 'Einträge pro Seite',
                      noResults: 'keine passenden Einträge gefunden',
                      count: '{from} bis {to} von {count} Einträgen|{count} Einträge|ein Eintrag'
                    },

                    pagination: {
                        chunk: 5
                    },

                    skin: 'table is-hoverable is-fullwidth',

                }
            },


            // ARTICLES
            articles: {

                data: [],
                columns: ['select', 'asset', 'name'],
                options: {
                    trackBy: 'id',
                    uniqueKey: 'id',
                    saveState: false,
                    perPage: 25,
                    orderBy: {
                        ascending: true,
                        column: 'name'
                    },

                    // custom table headings
                    headings: {

                        select(h) {
                            return "";
                        },
                        asset(h) {
                            return <lang labelKey="NEWSLETTER-ARTICLES-TBL_HEADER-ASSET"></lang>
                        },
                        name(h) {
                            return <lang labelKey="NEWSLETTER-ARTICLES-TBL_HEADER-NAME"></lang>
                        },

                    },

                    sortable: ['name'],
                    sortIcon: {
                        base:'fa',
                        up:'fa-sort-up',
                        down:'fa-sort-down',
                        is:'fa-sort'
                    },
                    filterByColumn: false,
                    filterable: false,

                    texts: {
                        filter: 'Filter Ergebnisse:',
                        filterPlaceholder: 'Suche',
                        limit: 'Einträge pro Seite',
                        noResults: 'keine passenden Einträge gefunden',
                        count: '{from} bis {to} von {count} Einträgen|{count} Einträge|ein Eintrag'
                    },

                    pagination: {
                        chunk: 5
                    },

                    skin: 'table is-striped is-hoverable is-fullwidth',

                    // custom filter functions
                    customFilters: [
                      {
                        name: 'search',
            						callback(row, string) {

            							if(string == null || string == "") {
            								return true;
            							}

            							string = string.toLowerCase();
            							return row.headline.toLowerCase().indexOf(string) > -1 || row.subheadline.toLowerCase().indexOf(string) > -1;

            						}
                      }

                    ],

                }
            },

            froalaConfig: {
              key: '',
              // 'insertImage',
              toolbarButtons: ['bold', 'italic', 'underline', '|', 'insertLink', '|', 'subscript', 'superscript', '|', 'align', '|', 'undo', 'redo'],
              placeholderText: 'Schreiben Sie hier Ihren Text ...',
      				wordPasteModal: false,
      				pastePlain: true,
              initOnClick: false,
      				heightMin: 300,
      				heightMax: 500,
              // quickInsertButtons: ['table', 'ul', 'ol'],
              quickInsertButtons: [],
              quickInsertTags: [],
              language: 'de',
              tableEditButtons: ['tableHeader', 'tableRemove', '|', 'tableRows', 'tableColumns', '-', 'tableCells', 'tableCellVerticalAlign', 'tableCellHorizontalAlign'],
              tableMultipleStyles: false,
              tableResizer: true,
              charCounterCount: false,
              // charCounterMax: 140,
              // quickInsertTags: [],        // disable quickInsertBar
            },

            appendedFormData: []
        }

    },

    computed: {

      mailTemplateTypes() {
          return this.$store.getters.getTermsByTaxonomy('MAIL_TEMPLATE_TYPES');
      },


      selectedNewsletter() {

          var self = this;

          // return this.siteNewsletters.find(n => n.newsletter == self.selectedNewsletterId);


          return this.siteNewsletters.find(function(n) {

              return n.isOriginal == true
                  ? n.id == self.selectedNewsletterId
                  : n.newsletter == self.selectedNewsletterId;

          });

          //  => _.id == self.selectedNewsletterId);


      },

      isEnabled() {
          return true;
          //return new Date(this.selectedNewsletter.scheduleDate) > new Date();
      },

      siteId() {

          return this.activeUser.site != null ? this.activeUser.site.id : 546;

      },

      newsletterSelectOptions() {

          var selectOptions = [];

          this.newsletters.forEach(newsletter => {

              selectOptions.push({
                  customLabel: null,
                  id: newsletter.id,
                  newsletter: newsletter.id,
                  scheduleDate: newsletter.scheduleDate,
                  name: this.formatDate2(newsletter.scheduleDate, false)
              })

          })

          selectOptions.sort(function(a, b) {
              return (a.scheduleDate < b.scheduleDate) ? -1 : ((a.scheduleDate > b.scheduleDate) ? 1 : 0);
          });

          // make the first newsletter preselected ...
          this.filterPharmaciesNewsletterName = selectOptions[0];

          return selectOptions;

      }

    },


    watch: {

      articleSearchString(newVal, oldVal) {

          if(newVal == oldVal) {
              return;
          }
          var self = this;

          setTimeout(function() {
              Event.$emit('vue-tables.tblNewsletterArticles.filter::search', newVal );
          }, 10);

      },

      markedRows(newVal, oldVal) {

          if(this.markedRows.length > this.maxArticles) {
              this.$notify.open( { content: 'Sie können nur maximal '+this.maxArticles+' Artikel auswählen', type: 'warning' })
          }

      },

      pharmaciesMarkedRows(newVal, oldVal) {

          if(this.pharmaciesMarkedRows.length != this.newsletterPharmacies.data.length) {
              this.pharmaciesMarkedAll = false;
          }

      },

      changedNewsletter(newVal, oldVal) {

          this.selectedNewsletterId = newVal.id;

      },

      selectedNewsletterId(newVal, oldVal) {

          this.appendedFormData = [];

          this.appendedFormData.push({ site: this.siteId });
          this.appendedFormData.push({ newsletterId: newVal });

      },

      filterPharmaciesNewsletterSent(newVal, oldVal) {

          Event.$emit('vue-tables.tblNewsletterPharmacies.filter::filter', {
              sentOption: newVal,
              newsletter: this.filterPharmaciesNewsletterName
          });

      },

      filterPharmaciesNewsletterName(newVal, oldVal) {

          Event.$emit('vue-tables.tblNewsletterPharmacies.filter::filter', {
              sentOption: this.filterPharmaciesNewsletterSent,
              newsletter: newVal
          });

      }
    },

    created() {

      // set licence key for froala
  		this.froalaConfig.key = this.$config.froalaKey;

      this.fetchData();

    },

    mounted() {

      this.initEventListeners();

    },

    beforeDestroy() {

      Event.$off('vue-tables.tblNewsletter.row-click');

    },

    methods: {

        isNewsletterSent(newsletters) {

            if(newsletters.length == 0) {
                return false;
            }

            var self = this;

            newsletters.some((newsletter) => {
                if(newsletter.newsletter == self.filterPharmaciesNewsletterName.newsletter && newsletter.email != null) {
                    return true;
                }
            })

        },

        getExcerpt(el, maxLength=580) {

            let str = "";

            if(typeof el.content != "undefined") {

                let text = el.content;

                if(text.length > maxLength) {
                    text = text.substr(0, maxLength);
                    str = text.substr(0, Math.min(text.length, text.lastIndexOf(" "))) + ' ...'
                } else {
                    str = text;
                }

                return str + ' <a class="readmore" href="http://www.apothekenkatalog.at/'+el.friendlyName+'" target="_blank">weiterlesen</a>';

            } else {

              return "";
            }

        },



        onDragComplete(elements, rowId) {

            var newsletterIndex = this.getNewsletterIndexById(rowId);
            var self = this;

            elements.forEach((element, index) => {
                element.sortorder = index;
            })

            this.$set(this.newsletters[newsletterIndex], 'elements', elements);

            // save/update
            this.entityCreateOrUpdate('newsletter', this.newsletters[newsletterIndex]);

        },

        dzRemoveFile() {


        },

        dzInit() {


        },

        dzSuccess(file, response) {

            var self = this;
            this.modal.isLoading = false;
            this.modal.isSaving = false;
            this.modal.type = 'progress';
            this.modal.title = 'Verarbeitung';
            this.modal.width = '640';
            this.modal.class = 'progressModal';

            this.showModal = true;

            this.$refs.vueDropzoneXls.$children[0].removeAllFiles();
            let taskLogId = response.taskLogId;

            self.refreshIntervalId = setInterval(function() {

                self.axios.get(self.$config.api + 'taskLog/' + taskLogId)
                    .then(function(response) {

                        self.progressStatus = response.data;

                        if(['Finished', 'Error'].indexOf(response.data.status) > -1) {

                            clearInterval(self.refreshIntervalId);

                            self.axios.get(self.$config.api + 'newsletter/subscribers?site='+self.siteId)
                                .then(function(response) {
                                    self.$notify.open({ content: 'Daten wurden erfolgreich importiert!', type: 'success'})
                                    self.recipients.data = response.data;
                                    self.closeModal();
                                })
                        }

                    });

            }.bind(self), 1000);


            setTimeout(function() {

                clearInterval(self.refreshIntervalId);
                self.showModal = false;

            }, 100000);

        },


        reminderOpen() {

            // Event.$off('vue-tables.tblNewsletterPharmacies.row-click');

            var templateID = this.mailTemplateTypes.NEWSLETTER_REMINDER.id;
            var self = this;

            this.modal.title = "Reminder versenden";
            this.modal.class = 'reminder';
            this.modal.type = 'reminder';
            this.modal.width = '720';
            this.showModal = true;
            this.modal.isLoading = true;

            this.axios.get(this.$config.api + 'mailTemplate?filters[type]='+templateID)
                .then((response) => {
                    self.reminderText = response.data.mailTemplate[0].body;
                    self.modal.isLoading = false;
                })
        },

        reminderSend() {

            this.modal.isSaving = true;
            var self = this;

            setTimeout(function() {

                self.closeModal();

                // todo: db send ...
                self.$notify.open({content: 'Reminder wurde erfolgreich versendet', type: 'success'});

            }, 1000);

        },

        pharmaciesToggleAll() {

            this.pharmaciesMarkedRows = this.pharmaciesMarkedAll ? [] : this.$refs.tblNewsletterPharmacies.data.map(row => row.id);
            this.pharmaciesMarkedAll = !this.pharmaciesMarkedAll;

        },

        initEventListeners() {

            var self = this;

            Event.$on('vue-tables.tblNewsletter.row-click', function(data) {
                self.$refs.tblNewsletter.toggleChildRow(data.row.id);
            });

            Event.$on('vue-tables.tblNewsletterPharmacies.row-click', function(data) {

                if(['p-default p-curve p-smooth pretty'].indexOf(data.event.target.parentElement.className) > -1) {
                    return false;
                }

                let foundIndex = self.pharmaciesMarkedRows.findIndex(function(row, index) { return row == data.row.id; });
                if(foundIndex > -1) {
                    self.pharmaciesMarkedRows.splice(foundIndex, 1);
                } else {
                    self.pharmaciesMarkedRows.push(data.row.id);
                }

            });
        },

        newsletterAdd() {

            this.modal.title = "Newsletter anlegen";
            this.modal.class = 'newsletterAdd';
            this.modal.type = 'newsletterAdd';
            this.modal.width = '480';
            this.modal.isLoading = false;
            this.showModal = true;

        },

        newsletterEdit(row) {

            this.tmpEntry = JSON.parse(JSON.stringify(row));

            this.modal.title = "Newsletter bearbeiten";
            this.modal.class = 'newsletterEdit';
            this.modal.type = 'newsletterEdit';
            this.modal.width = '480';
            this.modal.isLoading = false;
            this.showModal = true;

        },

        newsletterEditOk() {

            this.modal.isSaving = true;

            var newsletterIndex = this.getNewsletterIndexById(this.tmpEntry.id)
            this.$set(this.newsletters, newsletterIndex, this.tmpEntry);

            var self = this;

            this.entityCreateOrUpdate('newsletter', this.newsletters[newsletterIndex])
                .then(function(response) {
                    self.closeModal();
                })

        },

        newsletterAddOk() {

            this.modal.isSaving = true;
            var self = this;

            this.tmpEntry.channel = 12;
            this.tmpEntry.elements = [];

            this.entityCreateOrUpdate('newsletter', this.tmpEntry)
                .then(function(response) {

                    response.elements = [];
                    self.newsletters.push(response);

                    self.closeModal();
                })
        },

        newsletterDelete(row) {

            var self = this;

            this.entityDelete('newsletter', row.id, false, true).then(function(response) {

                for(var i in self.newsletters) {
                    if(self.newsletters[i].id == row.id) {
                        self.newsletters.splice(i, 1);
                        self.$notify.open({ content: 'Newsletter wurde erfolgreich entfernt!', type: 'success'});
                        break;
                    }
                }

            })

        },


        newsletterAppendArticles() {

            // get the index of the active row
            var newsletterIndex = this.getNewsletterIndexById(this.activeRowId);

            // create a new articles array (old values will be set new)
            this.$set(this.newsletters[newsletterIndex], 'elements', []);

            var self = this;

            this.modal.isSaving = true;

            // fetch all selected articles and push it into the elements array of the newsletter
            this.markedRows.forEach(function(rowId) {

                self.newsletters[newsletterIndex].elements.push({
                    newsletter: self.activeRowId,
                    catalogPageElement: self.articles.data.find(function(article) { return article.id == rowId }),
                    sortorder: self.newsletters[newsletterIndex].elements.length
                });

            })

            // save/update
            this.entityCreateOrUpdate('newsletter', self.newsletters[newsletterIndex])
                .then(function(response) {
                    self.closeModal();
                })

        },


        newsletterArticleRemove(rowId, articleIndex) {

            /*
            var self = this;
            var newsletterIndex = this.getNewsletterIndexById(rowId);
            self.newsletters[newsletterIndex].elements.splice(articleIndex, 1);
            this.entityCreateOrUpdate('newsletter', this.newsletters[newsletterIndex]).then(function(response) {});
            */

        },

        newsletterSave(isSilent = false) {

            this.isSaving = true;

            let saveObj = {
                id: "",
                site: this.siteId,
                newsletter: this.selectedNewsletter.id,
                email: this.selectedNewsletter.email,
                introText: this.selectedNewsletter.introText,
                salutation: this.selectedNewsletter.salutation,
                additionalText: this.selectedNewsletter.additionalText,
                subject: this.selectedNewsletter.subject,
                elements: []
            }

            if(this.selectedNewsletter.isOriginal == false) {

                saveObj.id = this.selectedNewsletter.id;
                saveObj.newsletter = this.selectedNewsletter.newsletter;

                this.selectedNewsletter.elements.forEach(element => {
                    saveObj.elements.push({
                        siteNewsletter: this.selectedNewsletter.id,
                        catalogPageElement: element.catalogPageElement,
                        content: element.content,
                        sortorder: element.sortorder
                    })
                })

            }


            var self = this;

            return new Promise(function(resolve, reject) {
                self.entityCreateOrUpdate('siteNewsletter', saveObj, { isSilent: isSilent })
                    .then((response) => {

                        if(self.selectedNewsletter.isOriginal == true) {

                            self.selectedNewsletter.id = response.id;

                            response.elements = [];

                            self.selectedNewsletter.elements.forEach((element) => {
                                response.elements.push({
                                    siteNewsletter: response.id,
                                    catalogPageElement: element.catalogPageElement.id,
                                    sortorder: element.sortorder
                                })
                            })

                            self.entityCreateOrUpdate('siteNewsletter', response, { isSilent: isSilent })
                                .then((response) => {
                                    self.selectedNewsletter.isOriginal = false;
                                    resolve();
                                })

                        } else {

                            resolve();

                        }


                    });
            });

        },

        newsletterSend() {

            this.progressStatus = null;
            this.modal.title = "Newsletter versenden";
            this.modal.class = 'newsletter';
            this.modal.type = 'newsletter';
            this.modal.width = '480';
            this.showModal = true;

        },

        newsletterSendOk() {

            this.showModal = true;
            this.isSending = true;

            this.progressStatus = null;
            this.modal.title = "Newsletter versenden";
            this.modal.class = 'sendNewsletter';
            this.modal.type = 'progress';
            this.modal.width = '480';
            this.showModal = true;

            var self = this;

            this.newsletterSave(true)
                .then((response) => {

                    self.axios.get(self.$config.api + 'newsletter/send?siteNewsletter='+self.selectedNewsletter.id)
                        .then((response) => {

                            let taskLogId = response.data.taskLogId;

                            self.refreshIntervalId = setInterval(function() {

                                self.axios.get(self.$config.api + 'taskLog/' + taskLogId)
                                    .then(function(response) {

                                        self.progressStatus = response.data;

                                        if(['Finished', 'Error'].indexOf(response.data.status) > -1) {

                                            clearInterval(self.refreshIntervalId);

                                            if(response.data.status == 'Finished') {
                                                self.$notify.open({ content: 'Newsletter wurde erfolgreich versendet!', type: 'success'})
                                            }

                                            self.progressStatus = null;
                                            self.modal.isSaving = false;
                                            self.isSending = false;
                                            self.closeModal();

                                        }

                                    });

                            }.bind(self), 1000);

                        })

                })

        },

        newsletterSendTest() {

            this.progressStatus = null;
            this.modal.title = "Testnewsletter versenden";
            this.modal.class = 'testNewsletter';
            this.modal.type = 'testNewsletter';
            this.modal.width = '480';
            this.showModal = true;

        },

        newsletterSendTestOk() {

            if(!this.validateEmail(this.testRecipient)) {
                this.$notify.open({ content: 'Bitte geben Sie eine korrekte Email Adresse ein!', type: 'warning'});
                return false;
            }

            this.isSendingTest = true;
            this.modal.isSaving = true;

            var self = this;

            this.newsletterSave(true).then(response => {



                this.axios.get(this.$config.api + 'newsletter/send?siteNewsletter='+this.selectedNewsletter.id+'&testRecipient='+this.testRecipient)
                    .then((response) => {

                        let taskLogId = response.data.taskLogId;

                        this.refreshIntervalId = setInterval(function() {

                            self.axios.get(self.$config.api + 'taskLog/' + taskLogId)
                                .then(function(response) {

                                    self.progressStatus = response.data;

                                    if(['Finished', 'Error'].indexOf(response.data.status) > -1) {

                                        clearInterval(self.refreshIntervalId);
                                        self.$notify.open({ content: 'Email wurde erfolgreich versendet!', type: 'success'})
                                        self.progressStatus = null;
                                        self.modal.isSaving = false;
                                        self.testRecipient = "";
                                        self.isSendingTest = false;

                                        self.closeModal();

                                    }

                                });

                        }.bind(self), 1000);

                    })

            })

        },


        siteNewsletterAppendArticles() {

            var self = this;

            // create a new articles array (old values will be set new)
            this.$set(this.selectedNewsletter, 'elements', []);

            this.modal.isSaving = true;

            // fetch all selected articles and push it into the elements array of the newsletter
            this.markedRows.forEach(function(rowId) {

                self.selectedNewsletter.elements.push({
                    newsletter: self.selectedNewsletter.newsletter,
                    catalogPageElement: self.articles.data.find(function(article) { return article.id == rowId }),
                    sortorder: self.selectedNewsletter.elements.length
                });

            })

            this.closeModal();


        },


        articleSearch() {
            Event.$emit('vue-tables.tbl-newsletterArticles.filter::search', this.articleSearchString);
        },

        closeModal() {

            // in case we've running an interval
            clearInterval(this.refreshIntervalId);

            Event.$off('vue-tables.tblNewsletter.row-click');
            Event.$off('vue-tables.tblNewsletterPharmacies.row-click');

            this.testRecipient = "";
            this.isSendingTest = false;
            this.progressStatus = null;

            this.modal.isSaving = false;
            this.showModal = false;
            this.tmpEntry = {
                id: '',
                scheduleDate: '',
                name: '',
                elements: []
            };
            this.activeRowId = null;
            this.activeRowIndex = null;
            this.markedRows = [];

            this.initEventListeners();
        },

        getNewsletterIndexById(rowId) {

            var newsletterIndex = "";

            for(let i in this.newsletters) {
                if(this.newsletters[i].id == rowId) {
                    newsletterIndex = i;
                    break;
                }
            }

            return newsletterIndex;

        },


        getImagePath(asset) {

            if(asset != null) {
                return this.$config.assets + asset.path + '/' + asset.filename;
            }
            return "";

        },


        fetchData() {

            this.isLoading = true;

			var self = this;

            if(this.userRole == 'Administrator') {

                function getCurrentOnlineCatalog() {
                    return self.axios.get(self.$config.api + 'catalog?filters[isOnline]=1')
                }
                function getPharmacies() {
                    return self.axios.get(self.$config.api + 'site?filters[newsletter]=1&include=site.newsletters')
                }
                function getNewsletter() {
                    return self.axios.get(self.$config.api + 'newsletter?include=newsletter.elements&liteCatalogPageElement=1&filters[channel]=12&orderBy=newsletterElement.sortorder');
                }

                // make the request
                this.axios.all([getCurrentOnlineCatalog(), getPharmacies(), getNewsletter()])
                    .then(self.axios.spread(function (currentCatalog, pharmacies, newsletter) {

                        self.currentCatalogName = currentCatalog.data.catalog[0].displayName;
                        self.newsletters = newsletter.data.newsletter;
                        self.newsletterPharmacies.data = pharmacies.data.site;
                        self.isLoading = false;

                    })).catch(function(error) {
                        self.isLoading = false;
                        console.log('Error: ', error.message);
                    });


            } else {

                function getCurrentOnlineCatalog() {
                    return self.axios.get(self.$config.api + 'catalog?filters[isOnline]=1')
                }

                function getNewsletter() {
                    return self.axios.get(self.$config.api + 'newsletter?include=newsletter.elements&liteCatalogPageElement=1&filters[channel]=12&orderBy=newsletterElement.sortorder,newsletter.scheduleDate,siteNewsletterElement.sortorder');
                }

                function getSiteNewsletter() {
                    return self.axios.get(self.$config.api + 'siteNewsletter?include=siteNewsletter.elements,siteNewsletterElement.products,siteNewsletterElementProduct.product&liteCatalogPageElement=1&filters[site]='+self.siteId+'&orderBy=siteNewsletterElement.sortorder');
                }

                function getRecipients() {
                    return self.axios.get(self.$config.api + 'newsletter/subscribers?site='+self.siteId);
                }

                // make the get request
                this.axios.all([getCurrentOnlineCatalog(), getNewsletter(), getSiteNewsletter(), getRecipients()])

                    .then(self.axios.spread(function (currentCatalog, mainNewsletter, siteNewsletter, siteRecipients) {

                        self.currentCatalogName = currentCatalog.data.catalog[0].displayName;

                        var currentDate = new Date();
                        var closestDate = Infinity;
                        var newsletterFirstShown = "";
                        var newslettObj = {};


                        if(Array.isArray(siteRecipients.data)) {
                            self.recipients.data = siteRecipients.data;
                        } else {
                            self.$notify.open({ content: 'Warning, malformed Recipients!', type: 'warning'});
                        }


                        mainNewsletter.data.newsletter.forEach(function(newsletter) {

                            newsletter.newsletter = newsletter.id;
                            self.newsletters.push(newsletter);


                            // create our newsletterObj
                            var newslettObj = {};
                            // newslettObj.newsletter = newsletter.id;
                            newslettObj.name = newsletter.name;
                            newslettObj.scheduleDate = newsletter.scheduleDate;
                            newslettObj.channel = newsletter.channel;

                            // check if this is a custom newsletter
                            let foundIndex = siteNewsletter.data.siteNewsletter.findIndex(s => s.newsletter == newsletter.id);

                            if(foundIndex > -1) {

                                newslettObj.isOriginal = false;
                                newslettObj.id = siteNewsletter.data.siteNewsletter[foundIndex].id;
                                newslettObj.newsletter = newsletter.id;
                                newslettObj.site = siteNewsletter.data.siteNewsletter[foundIndex].site;
                                newslettObj.subject = siteNewsletter.data.siteNewsletter[foundIndex].subject;
                                newslettObj.salutation = siteNewsletter.data.siteNewsletter[foundIndex].salutation;
                                newslettObj.introText = siteNewsletter.data.siteNewsletter[foundIndex].introText;
                                newslettObj.additionalText = siteNewsletter.data.siteNewsletter[foundIndex].additionalText;
                                newslettObj.elements = siteNewsletter.data.siteNewsletter[foundIndex].elements;

                                newslettObj.elements.forEach(e => {

                                    e.productSlots = [
                                        e.products.find(p => p.sortorder == 0),
                                        e.products.find(p => p.sortorder == 1),
                                        e.products.find(p => p.sortorder == 2)
                                    ];

                                })


                            // if it isn't a custom newsletter yet, we load the default values
                            } else {

                                newslettObj.isOriginal = true;
                                newslettObj.id = newsletter.id;
                                newslettObj.newsletter = null;
                                newslettObj.subject = newsletter.name;
                                newslettObj.salutation = "";
                                newslettObj.introText = "";
                                newslettObj.additionalText = "";
                                newslettObj.elements = newsletter.elements;


                            }


                            // find the newsletter with the closest date to now
                            // and store it in "newsletterFirstShown"
                            let scheduleDate = new Date(newslettObj.scheduleDate);

                            if (scheduleDate.getTime() >= currentDate.getTime() && scheduleDate.getTime() < closestDate) {
                                closestDate = currentDate.getTime();
                                newsletterFirstShown = newslettObj;
                            }

                            self.siteNewsletters.push(newslettObj);

                        })

                        if(newsletterFirstShown != "") {

                            /*
                            self.selectedNewsletterId = newsletterFirstShown.newsletter;
                            self.selectedNewsletter = newsletterFirstShown;
                            self.changedNewsletter = {
                                id: newsletterFirstShown.newsletter,
                                newsletter: newsletterFirstShown.newsletter,
                                name: self.formatDate2(newsletterFirstShown.scheduleDate, false),
                                customLabel: ''
                            }
                            */

                        }

                        self.appendedFormData.push({ site: self.siteId });
                        // self.appendedFormData.push({ newsletterId: newVal });

                        self.isLoading = false;

                    })).catch(function(error) {
                        self.isLoading = false;
                        console.log('Error: ', error.message);
                    });


            }


        },


        loadArticles(rowId) {

            var self = this;

            this.activeRowId = rowId;
            this.modal.title = "Artikel";
            this.modal.type = "articles";
            this.modal.class = 'tbl-newsletterArticles vcenter';
            this.modal.width = '860';
            this.modal.isLoading = true;
            this.showModal = true;

            var newsletterIndex = this.getNewsletterIndexById(this.activeRowId);

            if(typeof this.newsletters[newsletterIndex].elements != 'undefined') {

                this.newsletters[newsletterIndex].elements.forEach(function(article) {
                    self.markedRows.push(article.catalogPageElement.id.toString());
                })
            }

            let url = this.$config.api + 'catalogPageElement/onlineCatalogArticles';

            this.axios.get(url).then(function(response) {

                self.articles.data =  response.data;
                self.modal.isLoading = false;

                Event.$on('vue-tables.tblNewsletterArticles.row-click', function(data) {

                    if(['p-default p-curve p-smooth pretty'].indexOf(data.event.target.parentElement.className) > -1) {
                        return false;
                    }

                    let foundIndex = self.markedRows.findIndex(function(row) { return row == data.row.id; });

                    if(foundIndex > -1) {
                        self.markedRows.splice(foundIndex, 1);
                    } else {
                        self.markedRows.push(data.row.id);
                    }

                });

            });
        },

    }
}
</script>


<style lang="scss">

    @import '~pretty-checkbox/src/pretty-checkbox.scss';
    .p-default {
        margin: 0;
    }
</style>

<style>

    .preview {
        white-space: normal;
        line-height: 1.2rem;
        text-align: left;
    }
    .preview .headline {
        font-size: 1rem;
        font-weight: bold;
    }
    .preview p {
        margin: 10px 0;
    }
    .preview ul, .preview ol {
        display: block;
        list-style: disc outside none;
        margin: 1em 0;
        padding: 0 0 0 20px;
        border: none;
    }
    .preview ol {
        list-style-type: decimal;
    }
    .preview ul li,
    .preview ol li {
        display: list-item;
        margin-bottom: 2px;
    }
    .preview a.readmore {
        background: none !important;
        display: inline !important;
        text-decoration: underline !important;
        font-weight: normal !important;
        border: none !important;
        text-transform: lowercase !important;
    }


    .VueTables__child-row-toggler {
        width: 16px;
        height: 16px;
        line-height: 16px;
        display: block;
        margin: 0 auto;
        text-align: center;
    }
    .VueTables__child-row-toggler--closed::before {
        font-family: 'aki';
        content: '\e92c';
        display: inline-block;
        width: 12px;
    }
    .VueTables__child-row-toggler--open::before {
        font-family: 'aki';
        content: '\e911';
        display: inline-block;
        width: 12px;
    }

</style>


<style scoped>


    .newsletterHeader .scheduleDate {
        text-transform: uppercase;
        font-size: 11px;
    }
    h2 {
        font-size: 1.3rem;
        margin-bottom: 25px;
    }

    .centered {
        max-width: 700px;
        margin: 0 auto;
    }
    .centered >>> .control > .control {
        max-width: 100%;
    }

    /*
    .centered .newsletterArticles {
        margin: 0 auto;
        width: 100%;
    }
    .centered >>> .columns.newsletterArticle {
        max-width: 100%;
        margin: 0;
        white-space: normal;
        border-bottom: 1px solid #eee;
        padding-bottom: 6px;
        margin-bottom: 6px;
    }
    .centered >>> .columns.newsletterArticle:last-child {
        border-bottom: none !important;
        margin-bottom: 0;
    }
    .centered >>> .columns.newsletterArticle span.delArticle {
        visibility: hidden;
        opacity:0;
        transition: opacity 0.5s ease;
    }
    .centered >>> .columns.newsletterArticle:hover span.delArticle:not(.is-disabled) {
        visibility: visible;
        opacity:1;
    }

    .centered >>> .columns.newsletterArticle:last-child {
        margin-bottom: 0;
    }
    .centered >>> .columns.newsletterArticle .column {
        padding: 10px 5px;
        line-height: 1.2rem;
    }
    .centered >>> .columns.newsletterArticle .column:first-child {
        padding-left: 0;
    }
    .centered >>> .columns.newsletterArticle .column:last-child {
        padding-right: 0;
    }
    .centered >>> .columns.newsletterArticle .imgWrapper {
        width: 200px;
        height: 130px;
        margin: 0 5px 0 0;
        background-color: #FFF;
        border: 1px solid #efefef;
        border-radius: 2px;
    }

    .centered >>> .columns.newsletterArticle .column .headline {
        display: block;
        margin-top: 5px;
        margin-bottom: 10px;
        font-size: 1.2rem;
    }

    */


    .hrLine {
        padding-top: 12px;
        border-bottom: 1px solid #EEE;
        margin: 0 -20px 12px -20px;
    }


    /* pharmacies table */
    .tbl-newsletterPharmacies >>> .status > td:first-child {
        position: relative;
    }
    .tbl-newsletterPharmacies >>> .status > td:first-child::after {
        background: transparent;
        content: "";
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        height: 100%;
        width: 5px;
    }
    .tbl-newsletterPharmacies >>> .status.SENT > td:first-child::after {
        background-color: #84ED51;
    }

    .tbl-newsletterPharmacies >>> .VueTables__table th:nth-child(2) {
        width: 180px;
    }
    .tbl-newsletter >>> .VueTables__table tbody tr:not(:last-child) td {
        border-bottom: 1px solid #ddd !important;
    }
    .tbl-newsletter >>> .VueTables__table th:first-child {
        width: 20px;
        max-width: 20px;
    }
    .tbl-newsletter >>> .VueTables__table th:nth-child(2) {
    }
    .tbl-newsletter >>> .VueTables__table th:nth-child(3) {
        max-width: 150px;
        width: 150px;
    }


    .tbl-newsletter >>> .VueTables__table td:first-child {
        position: relative;
    }
    .tbl-newsletter >>> .VueTables__table tr:not(.VueTables__child-row) td:last-child {
        text-align: right;
    }
    .tbl-newsletter >>> .VueTables__table tr:not(.VueTables__child-row) td:first-child {
        padding: 0;
    }
    .tbl-newsletter >>> .VueTables__table tr:not(.VueTables__child-row) td:first-child span {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        left: 0;
        right: 0;
    }

    .tbl-newsletter >>> .VueTables__table tr.VueTables__child-row td {
        cursor: default;
    }
    .tbl-newsletter >>> .VueTables__table tr.VueTables__child-row:hover {
        background: none !important;
    }

    .columns.articles {
        min-width: 640px;
        max-width: 80%;
        margin: 0 0 5px 0;
        padding: 10px;
        background-color: #F5F7F9;
        border-radius: 3px;
    }
    .columns.articles .column {
        padding: 0 5px;
        margin: 0;
        display: flex;
        align-items: center;
    }
    .columns.articles .imgWrapper {
        width: 150px;
        height: 100px;
        /*background-size: contain;*/
    }
    .columns.articles.new {
        margin: 0;
    }
    .columns.articles.new .column {
        justify-content: center;
    }


    .imgWrapper {
		background-repeat: no-repeat;
		background-position: 50% 50% !important;
		background-size: cover;
		width: 85px;
		height: 65px;
		margin: 0;
		background-color: #FFF;
		border: 1px solid #efefef;
		border-radius: 2px;
	}
	.imgWrapper[lazy=loading]  {
		background-size: 30% !important;
	}
    .imgWrapper[lazy=error]  {
		background-size: contain !Important;
	}

    .imgWrapper.plain {
        background: none;
        display: flex;
        justify-content: center;
        align-items: center;
    }




    /* articles modal */
    >>> .modal-card-body {
        overflow: auto;
    }
    .tbl-newsletterArticles >>> .modal-card {
        /*min-height: 640px;*/
        max-height: 640px;

    }
    .tbl-newsletterArticles >>> td {
        padding: 5px 8px;
    }
    .tbl-newsletter >>> th:first-child {
        width: 35px;
    }
    .tbl-newsletterArticles >>> th:first-child {
        width: 40px;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-left: 4px;
    }
    .tbl-newsletterArticles >>> th:nth-child(2) {
        width: 70px;
    }

    .tbl-newsletterArticles >>> td:first-child {
        position: relative;
        width: 35px;
    }
    .tbl-newsletterArticles >>> td:first-child .checkboxWrapper {
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        left: 0; right: 0;
        top: 0;
        bottom: 0;
        padding-left: 4px;
    }
    .tbl-newsletterArticles >>> td:nth-child(2) .imgWrapper {
		background-repeat: no-repeat;
		background-position: 50% 50% !important;
		background-size: cover;
		width: 70px;
		height: 50px;
		margin: 0;
		background-color: #FFF;
		border: 1px solid #efefef;
		border-radius: 2px;
	}
	.tbl-newsletterArticles >>> td:nth-child(2) .imgWrapper[lazy=loading] {
		background-size: 30% !important;
	}
    .tbl-newsletterArticles >>> td:nth-child(2) .imgWrapper[lazy=error] {
		background-size: contain !important;
	}


    /* pharmacies */
    .tbl-newsletterPharmacies >>> th:first-child {
        width: 35px;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-left: 4px;
    }
    .tbl-newsletterPharmacies >>> td:first-child {
        position: relative;
        width: 35px;
    }
    .tbl-newsletterPharmacies >>> td:first-child .checkboxWrapper {
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        left: 0; right: 0;
        top: 0;
        bottom: 0;
        padding-left: 4px;
    }


    /* recipients table */
    .tbl-newsletterRecipients >>> th:last-child {
        width: 25px;
    }
    .tbl-newsletterRecipients >>> tr:not(.VueTables__no-results) td:last-child {
        text-align: right;
    }
    .tbl-newsletterRecipients >>> td:last-child .icon {
        vertical-align: middle;
    }
</style>
